import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useSprFiles } from '../spr-files';
import { useColumns } from './spr-file-in-progress-columns';

export const SPR_FILES_IN_PROGRESS_IDENTIFIER = 'SPR_FILES_IN_PROGRESS';
export const SPR_FILES_IN_PROGRESS_VERSION = 12;

export function SprFilesInProgress() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useSprFiles({
    evidenceProps: {
      identifier: SPR_FILES_IN_PROGRESS_IDENTIFIER,
      version: SPR_FILES_IN_PROGRESS_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.IN_PROGRESS,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__SPR_FILES_IN_PROGRESS__TABLE__TITLE',
          defaultMessage: 'Spisy SPR - V řešení',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
